<template>
  <vue-slick-popover
    v-click-outside="clickOut"
    v-if="isPopoverVisible"
    :popover-options="popoverOptions"
    @closePopover="closePopover"
  >
    <vue-slick-popover-content>
      <AtomResult
        v-if="roundData.game === 1"
        :round-data="roundData"
        @closePopover="closePopover"
      />
      <AtomWarResult
        v-if="roundData.game === 2"
        :round-data="roundData"
        @closePopover="closePopover"
      />

    </vue-slick-popover-content>
  </vue-slick-popover>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import AtomResult from '@components/common/history/atom-result.vue';
import AtomWarResult from '@components/common/history/atom-war-result.vue';

export default {
  components: {
    AtomResult,
    AtomWarResult,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    },
    isPopoverVisible: { type: Boolean, default: false },
    popoverOptions: { type: Object, default: () => ({})},
  },
  watch: {
    isPopoverVisible: function(newVal){
      // this.$log.info('isPopoverVisible', newVal);
      this.openTime = 0;
    },
  },
  data() {
    return {
      openTime: 0,
    }
  },
  // do not forget this section
  directives: {
    ClickOutside
  },
  methods: {
    closePopover() {
      // console.log('HistoryDetail - closePopover')
      this.$emit('closePopover');
    },
    clickOut () {
      if(this.openTime > 0){
        this.closePopover();
        // this.$log.info('[0] clickOut', this.openTime);
      }
      this.openTime = 1;
    },
  }
}
</script>

<style>
  .history-detail {
    text-align: left;
    display: inline-block;
    border-radius: 5px;
    position: relative;
    line-height: 16px;
    font-weight: 400;
    z-index: 200000;
    -webkit-box-shadow: 0 5px 15px rgba(0,0,0,.3);
    box-shadow: 0 5px 15px rgba(0,0,0,.3);
    background: #283152;
    margin-bottom: -5px;
    width: 280px;
    font-size: 12px;
    color: #fff;
    border: 1px solid #ebebeb;
    cursor: default;
  }
</style>
